import { createApp, h } from 'vue';

import { uicomponents } from 'uicomponents';
import { getStore, storeKey } from '@/utils/storeAccess';
import { getRouter } from '@/utils/routerAccess';

let visiblePopUps = [];

function getPopUpId(props) {
  const componentId = props?.props?.id;

  if (props?.message || componentId) {
    const otherProps = ['messages', 'title', 'message'];

    let popUpId = otherProps.reduce((acc, prop) => {
      return acc + (props[prop] || '');
    }, '');

    if (componentId) {
      popUpId = componentId;
    }

    return popUpId;
  }

  return null;
}

export function mount(el, component, props, options = {}) {
  let app;
  const store = getStore();
  const i18n = store?.state.event.translator?.i18n ?? { global: { t: msg => msg } };
  const promise = new Promise((resolve, reject) => {
    app = createApp({
      name: 'service-mountstage',
      methods: {
        closechild() {
          if (this.$children[0] && this.$children[0].close) {
            this.$children[0].close();
          }
        }
      },
      render() {
        const popUpId = getPopUpId(props);

        if (popUpId) {
          if (visiblePopUps.indexOf(popUpId) > -1) {
            return;
          }
          visiblePopUps.push(popUpId);
        }

        const injectedOns = Object.keys(options.on || {}).reduce((accum, cbname) => {
          const callback = options.on[cbname];
          accum[cbname] = reason => {
            if (options.closeOnCTAClick) {
              close();
            }
            callback(reason)
              ?.then(res => resolve(res))
              ?.catch(err => reject(err));
          };
          return accum;
        }, {});
        const on = {
          onHide(reason) {
            close();
            resolve(reason);
          },
          onCancel(reason) {
            close();
            if (reason) {
              reject(reason);
            }
          },
          ...injectedOns
        };
        const optionsWithoutOn = {
          ...options
        };
        optionsWithoutOn.on = undefined;
        return h(component, {
          ...props,
          props: { ...on, ...props.props },
          ...on,
          ...optionsWithoutOn
        });
      }
    });
    app.config.globalProperties.$router = getRouter();
    app.config.globalProperties.$store = store;
    app.config.globalProperties.$t = i18n.global.t;
    app.use(uicomponents, {
      $trackEvent: () => {}
    });
    if (store) {
      app.use(store, storeKey);
    }
    app.mixin({
      $t: i18n.global.t,
      $i18n: i18n
    });

    app.use(i18n).mount(el);
  });

  function close(closechild = false) {
    const popUpId = getPopUpId(props);

    if (popUpId) {
      visiblePopUps.splice(visiblePopUps.indexOf(popUpId), 1);
    }

    if (closechild) {
      app.closechild();
    } else {
      app.unmount();
      el.remove();
    }
  }

  return { promise, ref: app, close };
}

export function openTvWindow(url) {
  let params = 'width=' + screen.width;
  params += ', height=' + screen.height;
  params += ', top=0, left=0';
  params += ', fullscreen=yes';
  params += ', directories=no';
  params += ', location=no';
  params += ', menubar=no';
  params += ', resizable=no';
  params += ', scrollbars=no';
  params += ', status=no';
  params += ', popup=yes';
  params += ', toolbar=no';

  const tvWindow = window.open(url, 'tvWindow', params);
  if (window.focus) {
    tvWindow.focus();
  }

  watchTvWindow(tvWindow);
  return tvWindow;
}

export function watchTvWindow(tvWindow) {
  let closingInterval = null;
  let tries = 0;

  const checkClosed = () => {
    if (tvWindow.closed) {
      getStore()?.commit('event/stage/setTvWindow', undefined);
      clearInterval(closingInterval);
    } else if (tries > 2) {
      tries = 0;
      clearInterval(closingInterval);
    } else {
      tries++;
    }
  };

  tvWindow.onunload = () => {
    clearInterval(closingInterval);
    closingInterval = setInterval(checkClosed, 1000);
  };
}
